import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { DataContext } from "../../components/layouts/main-layout";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import InputField from "../../components/forms/input-field";
import AddButton from "../../components/buttons/button";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import { api } from "../../redux/apis/api";
import successToast from "../../components/helper-components/success-toast";
import errorToast from "../../components/helper-components/error-toast";

const EditUserCreation = () => {
  const { permissionFn } = useContext(DataContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/cpos/app/user/getById?store_app_user_id=${id}`)
      .then((res) => {
        const data = res.data?.data ?? res.data;
        const user = Array.isArray(data) ? data[0] : data;
        setInitialValues({
          user_name: user?.user_name ?? "",
          store_app_use_phone_number: user?.store_app_use_phone_number ?? "",
        });
        setLoading(false);
      })
      .catch((err) => {
        errorToast(err?.response?.data?.message ?? "Failed to fetch user");
        setLoading(false);
      });
  }, [id]);

  const onSubmit = (values, { setSubmitting }) => {
    api
      .post("/cpos/app/user/update", {
        store_app_user_id: id,
        user_name: values.user_name,
        store_app_use_phone_number: values.store_app_use_phone_number,
      })
      .then((res) => {
        successToast(res.data?.message ?? "User updated successfully");
        navigate("/user-creation");
      })
      .catch((err) => {
        errorToast(err?.response?.data?.message ?? "Failed to update user");
      })
      .finally(() => setSubmitting(false));
  };

  if (loading) return <LoadingSpinner />;
  if (!initialValues) return null;

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="store_execution_process"
      title="Edit User"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          user_name: Yup.string().required("User Name is required"),
          store_app_use_phone_number: Yup.string()
            .matches(/^\d{10}$/, "Enter a valid 10-digit mobile number")
            .required("Phone Number is required"),
        })}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="h-full flex flex-col justify-between">
            <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 pt-5">
              <InputField
                type="text"
                name="user_name"
                placeholder="Enter user's full name"
                label="User Name"
                isRequired={true}
                labelWidth="10.5rem"
              />
              <InputField
                type="text"
                name="store_app_use_phone_number"
                placeholder="Enter 10-digit mobile number"
                label="Phone Number"
                isRequired={true}
                labelWidth="10.5rem"
              />
            </div>
            <div
              className="flex justify-end gap-3 px-10 sticky bg-white py-4 invoice-bottom-container"
              style={{ bottom: 0 }}
            >
              <button
                type="button"
                onClick={() => navigate("/user-creation")}
                className="px-6 py-2 rounded-md border border-gray-300 text-sm fw_500"
              >
                Cancel
              </button>
              <AddButton prefixIcon={false} text="Save" type="submit" loading={isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </InnerLayout>
  );
};

export default EditUserCreation;

 